import { MutationTree } from "vuex";
import { PersonListState } from "../states.store";
const proposalMutations: MutationTree<PersonListState> = <MutationTree<PersonListState>>{
};
export default proposalMutations;
